import * as Yup from 'yup';
import { Language, PushNotificationType } from '../enum';

const notificationSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .when("countOnly", {
      is: false,
      then: (schema) => schema.required("Title is required"),
      otherwise: (schema) => schema.nullable(),
    })
    .label("Title"),
  message: Yup.string()
    .trim()
    .when("countOnly", {
      is: false,
      then: (schema) => schema.required("Message is required"),
      otherwise: (schema) => schema.nullable(),
    })
    .label("Message"),
  type: Yup.string()
    .oneOf([PushNotificationType.corporate, PushNotificationType.individual, PushNotificationType.language, PushNotificationType.allUsers])
    .required("Type is required")
    .label("Type"),
  language: Yup.string()
    .oneOf([Language.english, Language.arabic])
    .when("type", {
      is: PushNotificationType.language,
      then: Yup.string().required("Language is required"),
      otherwise: Yup.string().nullable(),
    })
    .label("Language"),
  // locationId: Yup.string()
  //   .trim()
  //   .when("type", {
  //     is: PushNotificationType.location,
  //     then: Yup.string().required("Location ID is required"),
  //     otherwise: Yup.string().nullable(),
  //   })
  //   .label("Location"),
  countOnly: Yup.boolean().default(false).label("Count only"),
});

export default notificationSchema;